export default __webpack_public_path__ + "static/media/product_services.c43e53ed.svg";